import { ExclusionGroupEntityDtoSchema } from "../../../../../dtos/exclusion-group";

export const PluginExclusionGroupEntitySchema_2023_08_20 =
  ExclusionGroupEntityDtoSchema;
